<template>
	<div class="text-xs opacity-60">
		{{ stringaMultilingua('Ultimo aggiornamento', 'Last update', 'Letztes Update') }}:
		{{
			formatTimeAgo(DateTime.fromISO(updatedOn).toJSDate(), {
				messages: language === 'it' ? useTimeAgoMessagesIt : undefined,
			})
		}}
	</div>
</template>

<script setup>
	import {DateTime} from 'luxon'
	import {toRefs, computed} from 'vue'
	import {formatTimeAgo} from '@vueuse/core'
	import {messages as useTimeAgoMessagesIt} from '../../locales/it/useTimeAgo'

	const props = defineProps({
		updatedOn: String,
		locale: {
			type: String,
			default: 'it',
		},
	})
	const {updatedOn, locale} = toRefs(props)
	const language = computed(() => locale.value.split('-')[0])

	function stringaMultilingua(...params) {
		switch (language.value) {
			case 'it':
				return params[0]
			case 'de':
				return params[2]
			default:
				// 2
				return params[1]
		}
	}
</script>
